module.exports = __webpack_public_path__ + "img/map_chileebuscovid19.66bff98b.png";